import React, { useEffect, useState } from "react";
import {
    Box,
    Chip,
    Card,
    Typography,
    CardContent,
    CardMedia,
    Button,
    Stack,
    IconButton
} from "@mui/material";
import ReactPlayer from "react-player";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import MusicVideoIcon from '@mui/icons-material/MusicVideo';
import VideocamIcon from '@mui/icons-material/Videocam';
import ImageIcon from '@mui/icons-material/Image';
import MediaPreviewDialog from "./MediaPreviewDialog";
import AddQuestionDialog from "./AddQuestionDialog";
import api_service from "../../network/api_callbacks";
import { toast } from "react-toastify";
import DeleteIcon from '@mui/icons-material/Delete';

const QuestionListItem = ({ question_data, showAddQuestionDialog, setShowAddQuestionDialog, editableQuestion, setEditableQuestion, callQuestionListApi }) => {

    const [questionData, setQuestionData] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [currentMultimedia, setCurrentMultimedia] = useState(null);

    useEffect(() => {
        setQuestionData(question_data)
    }, [])

    const handlePreview = (media) => {
        setCurrentMultimedia(media);
        setPreviewOpen(true);
    };

    const getNextStatus = (currentStatus) => {
        switch (currentStatus) {
            case 'active':
                return 'in-review';
            case 'in-review':
            default:
                return 'active';
        }
    };

    const handleStatusToggle = (index, item, currentStatus) => {
        const nextStatus = getNextStatus(currentStatus);
        console.log("Toggling from", currentStatus, "to", nextStatus);
        updateQuestionStatus(item?._id, index, currentStatus, nextStatus)
    };

    const updateQuestionStatus = async (questionId, index, currentStatus, nextStatus) => {
        try {
            const response = await api_service.updateQuestionStatus({ questionId, nextStatus })
            console.log('📘 Question Bank Data:', response);
            if (response?.status === 200) {
                setQuestionData((prev) =>
                    prev.map((item, i) =>
                        i === index ? { ...item, status: nextStatus } : item
                    )
                );
                toast.success(`Question status changes to ${response?.data?.status}`)
            }
            else {
                toast.error(`Question status have an issue - ${response?.status}`)
            }
        } catch (error) {
            toast.error(`Question status have an issue - ${error}`)
            console.error('❌ Failed to fetch Question Bank:', error);
        }
    }

    const deleteQuestion = async (question) => {
        try {
            const response = await api_service.deleteQuestion({ questionId: question })
            console.log('📘 Question deleted Data:', response);
            if (response?.status === 200) {
                toast.success(`Question deleted successfully.`)
                setEditableQuestion(null);
                setShowAddQuestionDialog(false)
                callQuestionListApi();
            }
            else {
                toast.error(`Have an issue to delete question`)
            }
        } catch (error) {
            toast.error(`Question status have an issue - ${error}`)
            console.error('❌ Failed to delete question:', error);
        }
    }

    const handleItemClick = (item, index) => {
        setEditableQuestion(item);
        setShowAddQuestionDialog(true);
        console.log("clicked!!", item);
    }

    const handleAddDialogOnClose = () => {
        console.log("handleAddDialogOnClose")
        setEditableQuestion(null);
        setShowAddQuestionDialog(false)
    }

    const handleAddDialogOnSubmit = (data) => {
        const question = data?.question;
        const mode = data?.mode;
        console.log("Question submitted question>>:", question);

        if (mode === "delete") {
            deleteQuestion(question?._id)
        }
        else {
            setQuestionData((prev) => {
                const index = prev.findIndex(q => q?.id === question?.id);

                if (index === -1 && mode !== "delete") {
                    console.log("Addition done");
                    return [...prev, question];
                }

                if (mode === "delete") {
                    console.log("Deletion done");
                    return prev.filter(q => q?.id !== question?.id);
                }

                // Update existing item (e.g., in edit mode)
                return prev.map((item, i) => i === index ? { ...question } : item);
            });
            setEditableQuestion(null);
            setShowAddQuestionDialog(false)
        }
    }

    return (
        <>
            <Stack spacing={2}>
                {Array.isArray(questionData) && questionData?.map((item, index) => (
                    <Card key={item?.id} sx={{ borderRadius: 2, overflow: "hidden", outline: "1px solid grey" }}>

                        <CardContent>

                            <Box mt={0} display="flex" justifyContent="space-between" alignItems="start">
                                <Box mt={0} display="flex" flexDirection="column" alignItems="flex-start"
                                    onClick={() => { handleItemClick(item, index) }}>
                                    <Typography variant="h6" color="text" textAlign="justify" sx={{ paddingRight: 1, fontWeight: "bold", mt: 0 }}>
                                        {index + 1}&gt; &nbsp;{item?.questionText}
                                    </Typography>
                                    {item?.tags?.filter(item => item.type !== "difficulty")
                                    .map((item, index) => (
                                        <span
                                            key={index}
                                            style={{
                                                padding: "4px 8px",
                                                background: "#eee",
                                                borderRadius: "0px",
                                                backgroundColor: 'transparent'
                                            }}
                                        >
                                            {`${item.type} : ${item.details.level ?? item.details.name}`}
                                        </span>
                                    ))}
                                </Box>

                                <Box mt={0} display="flex" flexDirection="column" alignItems="flex-end" >
                                    <Box mt={0} display="flex" flexDirection="row" alignItems="flex-end">
                                        <IconButton onClick={() => { handleAddDialogOnSubmit(item) }} sx={{ mr: 2 }}>
                                            <DeleteIcon />
                                        </IconButton>
                                        <Chip
                                            label={item?.status || ''}
                                            data-status={item?.status}
                                            onClick={(e) => handleStatusToggle(index, item, e.currentTarget.dataset.status)}
                                            size="medium"
                                            sx={{
                                                cursor: "pointer",
                                                backgroundColor:
                                                    item?.status === 'active'
                                                        ? '#4CAF50'
                                                        : item?.status === 'in-review'
                                                            ? '#FF9800'
                                                            : '#F44336',
                                                color: '#fff',
                                                fontWeight: 'bold',
                                                textTransform: 'capitalize'
                                            }}
                                        />
                                    </Box>
                                    <Typography variant="h6" sx={{ fontWeight: "bold", mt: 1 }}>
                                        {item?.questionType?.toUpperCase()}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* {item?.correctOptionIds && (
                                <Box
                                    mt={2}
                                    display="flex"
                                    justifyContent="flex-start"
                                    alignItems="center"
                                >
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            height: 40,
                                            width: "100%",
                                            borderColor: "success.main",
                                            backgroundColor: "success.light",
                                            color: "white",
                                            textTransform: "none",
                                            fontWeight: 600,
                                            px: 2,
                                        }}
                                        onClick={() => { handleItemClick(item, index) }}
                                    >
                                        {item.correctOptionIds[0]?.text}
                                    </Button>
                                    {(item?.multimedia?.type === 'image') && (
                                        <ImageIcon sx={{ marginLeft: 2, width: 40, height: 40 }}
                                            onClick={() => handlePreview(item.multimedia)}
                                        />
                                    )}
                                    {item?.multimedia?.type === 'audio' && (
                                        <MusicVideoIcon sx={{ marginLeft: 2, width: 40, height: 40 }}
                                            onClick={() => handlePreview(item?.multimedia)}
                                        />
                                    )}
                                    {item?.multimedia?.type === 'video' && (
                                        <VideocamIcon sx={{ marginLeft: 2, width: 40, height: 40 }}
                                            onClick={() => handlePreview(item?.multimedia)}
                                        />
                                    )}
                                </Box>
                            )} */}

                            <Box
                                mt={2}
                                display="flex"
                                justifyContent="flex-start"
                                alignItems="center"
                            >
                                <Button
                                    variant="outlined"
                                    sx={{
                                        height: 40,
                                        width: "100%",
                                        borderColor: "success.main",
                                        backgroundColor: "success.light",
                                        color: "white",
                                        textTransform: "none",
                                        fontWeight: 600,
                                        px: 2,
                                    }}
                                    onClick={() => { handleItemClick(item, index) }}
                                >
                                    {`Difficulty Level : ${item?.tags?.find(item => item?.type === "difficulty")?.details?.level}`}
                                </Button>
                                {(item?.multimedia?.mediaType === 'image') && (
                                    <ImageIcon sx={{ marginLeft: 2, width: 40, height: 40 }}
                                        onClick={() => handlePreview(item?.multimedia)}
                                    />
                                )}
                                {item?.multimedia?.mediaType === 'audio' && (
                                    <MusicVideoIcon sx={{ marginLeft: 2, width: 40, height: 40 }}
                                        onClick={() => handlePreview(item?.multimedia)}
                                    />
                                )}
                                {item?.multimedia?.mediaType === 'video' && (
                                    <VideocamIcon sx={{ marginLeft: 2, width: 40, height: 40 }}
                                        onClick={() => handlePreview(item?.multimedia)}
                                    />
                                )}
                            </Box>

                            {/* Options */}
                            {/* <Stack spacing={1} mt={3}>
                                {item.options.map((opt) => (
                                    <Button
                                        key={opt.id}
                                        variant="outlined"
                                        fullWidth
                                        sx={{
                                            justifyContent: "flex-start",
                                            borderColor:
                                                item.correctOptionIds[0].id === opt.id
                                                    ? "success.main"
                                                    : "grey.300",
                                            backgroundColor:
                                                item.correctOptionIds[0].id === opt.id
                                                    ? "success.light"
                                                    : "white",
                                            color:
                                                item.correctOptionIds[0].id === opt.id
                                                    ? "white"
                                                    : "text.primary"
                                        }}
                                    >
                                        {opt.text}
                                    </Button>
                                ))}
                            </Stack> */}
                        </CardContent>
                    </Card>
                ))}
            </Stack>
            <MediaPreviewDialog
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                multimedia={currentMultimedia}
            />
            <AddQuestionDialog
                editableQuestion={editableQuestion}
                setEditableQuestion={setEditableQuestion}
                handleAddDialogOnClose={handleAddDialogOnClose}
                open={showAddQuestionDialog}
                onClose={() => handleAddDialogOnClose}
                onSubmit={(data) => { handleAddDialogOnSubmit(data) }}
            />
        </>
    );
}

export default QuestionListItem;